<template>
    <div class="card-sidebar card-sidebar-mini" style="position:fixed; width: 6.5%;  height: 99vh; bottom: 0px; left:0px; background: #ffffff; border-top-left-radius: 18px; z-index: 10000; 
        padding: 1em 10px;">
        <div class="card-sidebar-headx" style="">
            <a href="/" style="color: #000000; text-transform: capitalize; font-size: 12px; font-weight: bolder; cursor: pointer; text-decoration: none;">
                <!-- <span id="appName" style="margin-left:0px; margin-top: 0.02em; padding-top: 0; display: block;">
                    <span style="font-family:Papyrus, fantasy;">Place Order</span>
                </span> -->
                <img src="/static/assets/images/brand001.png" class="img-responsive"/>
            </a>
            <p style="font-size: 8px; text-align: left; color: #ff0000;">easy-peasy</p>
            <hr/>
        </div>
        <div class="card-sidebar-body">
            <div class="card-sidebar-group-x">
                <div>
                    <li v-if="site_user_type == 2"><a class="card-link" href="/dashboard"><i class="fas fa-table"></i><span>Dashboard</span></a></li>
                    <li v-if="site_user_type == 1"><a class="card-link" href="/search"><i class="fas fa-store"></i><span><br>Order From</span></a></li>
                    <li v-if="site_user_type == 2"><a class="card-link" href="/manage/orders"><i class="fas fa-list"></i><span><br>Orders</span></a></li>
                    <li v-if="site_user_type == 1"><a class="card-link" href="/placed/orders"><i class="fas fa-list"></i><span><br>Orders</span></a></li>
                    <li><a class="card-link" href="#"><i class="fas fa-store"></i><span><br>Favorites</span></a> </li>
                </div>
            </div>
            <div class="card-sidebar-group-x" style="margin-top: 0em;">
                <!-- <h5 style="color: #999;">more<span style="display: none;">______________</span></h5> -->
                <div>
                    <li><a class="card-link" href="/settings"><i class="fas fa-gear"></i><span><br>Settings</span></a></li>
                    <li><a class="card-link" href="#"><i class="fas fa-bell"></i><span><br>Notifications</span></a></li>
                    <li><a class="card-link" href="#"><i class="fas fa-support"></i><span><br>Support</span></a></li>
                </div>
            </div>
            <div class="card-sidebar-group-x" style="margin-top: 2em;">
                <div>
                    <li><a class="card-link" href="#"><i class="fas fa-power-off"></i><span><br>Log out</span></a></li>
                </div>
            </div>
        </div>
        <div class="card-sidebar-footer" style="position:fixed; bottom: 10px; display: none;">
            <div style="">
                <div class="card-avatar-circle-xx" style=" text-align:left">
                    <img src="/static/assets/images/dummy-image.png"  style="width:30px; height: 30px; border-radius: 50%;"/>
                </div>
                <div style="text-align: center; display: none;">
                    <h4>{{ user.user_name }}</h4>
                    <p>last seen: Yesterday</p>
                    <!-- <p>{{ user.user_email }} {{ user.user_phone }}</p> -->
                    <a href="/manage/profile" class="btn sp-button-02-lt">View Profile</a>
                </div>
            </div>
        </div>
        <div style="position:fixed; bottom: 10px; ">
            <p style="font-size: 11px; text-align: center;">&COPY; 2023 <br> Place Order</p>
        </div>
    </div>
</template>

<style>
    .card-sidebar-group-x li {
        list-style: none;
        margin-bottom: 0.8em;
        text-align: center;
    }
    .card-sidebar-group-x li i{
        margin-right: 0.8em;
        padding: 0.82em 0.66em;
        border-radius: 38%;
        background: #eee;
        color: #666;
    }
    .card-sidebar-group-x li span{
        font-size: 10px;
    }
    .card-sidebar-group-x li a:hover{
        text-decoration: none;
    }
    .card-sidebar-group-x li a:hover span{
        color: #ff0000;
    }
</style>

<script>
    import services from './../../services/service'; // Service Class
    import AccountResources from './../Account/Resources/commonfunctions.js';

    //
    let service = new services();

    export default {
        name: 'ManageOrders',
        mixins: [AccountResources],
        data () {
            return {}
        },
    
        components: {},
        methods: {
            preset() {
                this.loading = true;
                //../
                let self = this;
                localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                    if(value != undefined) {
                        self.user = value;
                        self.setSiteUser();
                    }else {
                        self.loading = false;
                        //self.$router.push('/login')
                    }
                });
            },
        },
        created: function(){
            this.preset();
        }
    }
</script>


// WEBPACK FOOTER //
// SidebarMini.vue?6da1891a